interface InputInterface {
  pass?: string; // The pass field could be undefined
}

const validate = (input: InputInterface) => {
  interface ErrorsInterface {
    pass?: string;
  }

  let errors: ErrorsInterface = {};

  // Validación de contraseña
  if (!input.pass || !/^.{5,}$/.test(input.pass)) {
    errors.pass = 'Invalid password - The password must be at least 5 characters long.';
  }
  
  return errors;
};

export default validate;
